import { Directive, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[appOnlyNumber]',
    standalone: true,
})
export class OnlyNumberDirective {
    @Input() appOnlyNumber: boolean | any;

    @HostListener('keydown', ['$event']) onKeyDown(event: any) {
        const e = <KeyboardEvent>event;
        // tslint:disable-next-line
        const keyCode = e.keyCode;
        if (this.appOnlyNumber) {
            if (
                // 190, 110 for . and ,
                [46, 8, 9, 27, 13].indexOf(keyCode) !== -1 ||
                // Allow: Ctrl+A
                (keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
                // Allow: Ctrl+C
                (keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
                // Allow: Ctrl+V
                (keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
                // Allow: Ctrl+X
                (keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
                // Allow: home, end, left, right
                (keyCode >= 35 && keyCode <= 39)
            ) {
                // let it happen, don't do anything
                return;
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || keyCode < 48 || keyCode > 57) && (keyCode < 96 || keyCode > 105)) {
                e.preventDefault();
            }
        }
    }
}
